import { render, staticRenderFns } from "./DispatchedMultipleRecipientsEmailCommunication.vue?vue&type=template&id=9b9e3822&scoped=true"
import script from "./DispatchedMultipleRecipientsEmailCommunication.vue?vue&type=script&lang=ts"
export * from "./DispatchedMultipleRecipientsEmailCommunication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9e3822",
  null
  
)

export default component.exports